/* generated file, changes will be overwritten */
/** @public */
export const name: string = "html-validate";
/** @public */
export const version: string = "10.11.3";
/** @public */
export const homepage: string = "https://html-validate.org";
/** @public */
export const bugs: string = "https://gitlab.com/html-validate/html-validate/issues/new";
